export default {"src":"/_next/static/media/halal.150a4cf7.svg","height":22,"width":20,"blurWidth":0,"blurHeight":0};